import React from "react";

import {
    CreditCard,
    Car,
    ShieldCheck,
    IdCard,
    CheckCircle,
    Clock3,
    XCircle
} from "lucide-react";

import "./Documents.css";

function Documents({ profile }) {

    const documents = [

        {
            title: "Driving License",
            value: profile?.documents?.drivingLicense,
            verified: profile?.documents?.drivingLicenseVerified,
            icon: <CreditCard size={22} />
        },

        {
            title: "RC Book",
            value: profile?.documents?.rcBook,
            verified: profile?.documents?.rcBookVerified,
            icon: <Car size={22} />
        },

        {
            title: "Vehicle Insurance",
            value: profile?.documents?.insurance,
            verified: profile?.documents?.insuranceVerified,
            icon: <ShieldCheck size={22} />
        },

        {
            title: "Aadhaar Card",
            value: profile?.documents?.aadhaar,
            verified: profile?.documents?.aadhaarVerified,
            icon: <IdCard size={22} />
        }

    ];

    const renderStatus = (verified, value) => {

        if (!value) {

            return (

                <div className="hf-doc-status hf-pending">

                    <Clock3 size={15} />

                    Not Uploaded

                </div>

            );

        }

        if (verified) {

            return (

                <div className="hf-doc-status hf-verified">

                    <CheckCircle size={15} />

                    Verified

                </div>

            );

        }

        return (

            <div className="hf-doc-status hf-review">

                <XCircle size={15} />

                Under Review

            </div>

        );

    };

    return (

        <div className="hf-documents-card">

            <div className="hf-documents-header">

                <h2>

                    Documents Verification

                </h2>

                <p>

                    Upload and verify your required documents

                </p>

            </div>

            <div className="hf-documents-grid">

                {

                    documents.map((doc, index) => (

                        <div
                            key={index}
                            className="hf-document-item"
                        >

                            <div className="hf-document-top">

                                <div className="hf-document-icon">

                                    {doc.icon}

                                </div>

                                {renderStatus(doc.verified, doc.value)}

                            </div>

                            <h3>

                                {doc.title}

                            </h3>

                            <p>

                                {doc.value || "No document uploaded"}

                            </p>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}

export default Documents;